module.exports = __webpack_public_path__ + "static/media/noaccess.b182c95e.png";